import { m } from 'framer-motion';

import SvgIcon from '@mui/material/SvgIcon';
import Favorite from '@mui/icons-material/Star';
import Dashboard from '@mui/icons-material/Dashboard';
import Assignment from '@mui/icons-material/Assignment';

import { CONFIG } from "src/config-global";

import { Iconify } from 'src/components/iconify';
import { SvgColor } from "src/components/svg-color";

export const loadIcon = (type, name, ext = 'svg') => <SvgColor src={`${CONFIG.site.assetURL}/assets/icons/${type}/${name}.${ext}`} />;

export const ICONS = {
    home: loadIcon('navbar', 'ic-home'),
    job: loadIcon('navbar', 'ic-job'),
    blog: loadIcon('navbar', 'ic-blog'),
    chat: <Iconify icon="solar:stars-outline" />,
    mail: loadIcon('navbar', 'ic-mail'),
    user: loadIcon('navbar', 'ic-user'),
    file: loadIcon('navbar', 'ic-file'),
    lock: loadIcon('navbar', 'ic-lock'),
    tour: loadIcon('navbar', 'ic-tour'),
    order: loadIcon('navbar', 'ic-order'),
    label: loadIcon('navbar', 'ic-label'),
    blank: loadIcon('navbar', 'ic-blank'),
    app: loadIcon('navbar', 'ic-dashboard'),
    kanban: loadIcon('navbar', 'ic-kanban'),
    folder: loadIcon('navbar', 'ic-folder'),
    course: loadIcon('navbar', 'ic-course'),
    banking: loadIcon('navbar', 'ic-banking'),
    booking: loadIcon('navbar', 'ic-booking'),
    invoice: loadIcon('navbar', 'ic-invoice'),
    product: loadIcon('navbar', 'ic-product'),
    calendar: loadIcon('navbar', 'ic-calendar'),
    disabled: loadIcon('navbar', 'ic-disabled'),
    external: loadIcon('navbar', 'ic-external'),
    menuItem: loadIcon('navbar', 'ic-menu-item'),
    ecommerce: loadIcon('navbar', 'ic-ecommerce'),
    analytics: loadIcon('navbar', 'ic-analytics'),
    parameter: loadIcon('navbar', 'ic-parameter'),
    coupon: loadIcon('navbar', 'ic-coupon'),

    dashboard: <Dashboard />,
    assignment: <Assignment />,
    schedule: <Iconify icon="mdi:calendar-month" />,
    reports: <Iconify icon="mdi:file-report" />,
    list: <Iconify icon="mdi:format-list-bulleted-square" />,
    camera: <Iconify icon="mdi:camera" />,
    document: <Iconify icon="mdi:file-document-outline" />,

    favorites: <Favorite />,
    store: <Iconify icon="mdi:store" />,
    inStore: <Iconify icon="mdi:store-search" />,

    loading: <SvgIcon component={m.svg} animate={{ rotate: 360 }} transition={{ duration: 2, ease: 'linear', repeat: Infinity }} children={<Iconify icon="eva:loader-outline" />} />
};
